import { useRef, useState } from 'react';
import { Card } from '../../../../layout/Card.jsx';
import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { useDownloadBackup, useRestoreBackup } from '../../hooks/useBackup.js';
import { ConfirmRestoreModal } from './ConfirmRestoreModal.jsx';

export function BackupCard() {
  const downloadM = useDownloadBackup();
  const restoreM = useRestoreBackup();
  const fileRef = useRef(null);
  const [file, setFile] = useState(null);

  const pickFile = (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = '';
    if (f) setFile(f);
  };

  return (
    <Card>
      <div className="flex items-start gap-4">
        <div
          className="w-12 h-12 rounded-[12px] grid place-items-center text-white flex-shrink-0 text-[22px]"
          style={{ background: 'linear-gradient(135deg,#06B6D4,#0284C7)' }}
        >
          💾
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <h3 className="font-extrabold text-[15px] m-0">النسخ الاحتياطي والاستعادة</h3>
            <Pill variant="info">قاعدة البيانات + الصور</Pill>
          </div>
          <p className="text-[12.5px] text-ink-2 leading-relaxed mb-2">
            تنزيل نسخة احتياطية كاملة من النظام (كل الجداول والملفات المرفوعة) بملف واحد،
            أو استعادة نسخة محفوظة — مثلاً لسحب البيانات من الخادم الأونلاين
            واستيرادها في جهاز الصالة المحلي.
          </p>
          <div className="text-[11.5px] text-cyan-800 bg-cyan-50 border border-cyan-200 rounded-[8px] px-3 py-2 mb-3">
            ℹ️ الاستعادة تستبدل كل البيانات الحالية، ويُحفظ قبلها سناب أمان تلقائي على الخادم.
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => downloadM.mutate()}
              disabled={downloadM.isPending}
            >
              <Icon name="reports" size={14} />
              {downloadM.isPending ? 'جاري تحضير النسخة…' : 'تنزيل نسخة احتياطية كاملة'}
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => fileRef.current && fileRef.current.click()}
              disabled={restoreM.isPending}
            >
              <Icon name="plus" size={14} />
              {restoreM.isPending ? 'جاري الاستعادة…' : 'استعادة من ملف…'}
            </button>
            <input
              ref={fileRef}
              type="file"
              accept=".gz,application/gzip"
              className="hidden"
              onChange={pickFile}
            />
          </div>
        </div>
      </div>

      <ConfirmRestoreModal
        open={!!file}
        fileName={file ? file.name : ''}
        onClose={() => setFile(null)}
        onConfirm={async () => {
          await restoreM.mutateAsync(file, { onSuccess: () => setFile(null) });
        }}
        loading={restoreM.isPending}
      />
    </Card>
  );
}
